import { useEffect } from 'react';
import { useSystemApiWsClient } from '../context/SystemApiWsContext.js';
import { useAuthService } from '../context/AuthServiceContext.js';
import { useSync } from './useSync.js';
/**
 * Hook that listens for remote commands sent via WebSocket control messages
 * and executes the corresponding action (logout, sync, etc.).
 *
 * Should be mounted once at the app level (e.g. DashboardPage).
 */
export function useRemoteCommands() {
    const wsClient = useSystemApiWsClient();
    const authService = useAuthService();
    const { sync } = useSync();
    useEffect(() => {
        if (!wsClient)
            return;
        const unsub = wsClient.onControl('remoteCommand', (payload) => {
            const command = payload?.command;
            if (!command)
                return;
            console.log(`[useRemoteCommands] Received remote command: ${command}`);
            switch (command) {
                case 'logout':
                    wsClient.close();
                    authService.logout();
                    break;
                case 'sync':
                    sync();
                    break;
                default:
                    console.warn(`[useRemoteCommands] Unknown command: ${command}`);
            }
        });
        return unsub;
    }, [wsClient, authService, sync]);
}
//# sourceMappingURL=useRemoteCommands.js.map